import React, {useContext, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import MobileItem from "../../../../../../../../components/WMS/Mobile/MobileItem";
import Badge from "../../../../../../../../components/Badge";
import store from "../../../../../../../../store";
import ThumbnailAndNotification from "../../../../../../../../components/WMS/Mobile/ThumbnailAndNotification";
import {Grid} from "@mui/material";
import {FormattedMessage} from "react-intl";
import CustomButton from "../../../../../../../../components/CustomButton";
import {packingStepNames} from "../../../packingSteps";
import {beginMultiShipmentPacking} from "../../../../../../../../api/shipment/packing";
import {WmsItemsStatus} from "../../../../../../../../utils/WmsItemsStatus";
import {BarCodeScannerContext} from "../../../../../../../../contexts/barCodeScannerContext";
import MultiHiveModal from "../../MultiHiveModal";
import {patchWmsContainersWithCodebar} from "../../../../../../../../api/wms/wmsContainers/wmsContainers";
import WmsItemInformationPacking from "../WmsItemInformationPacking";
import {PackingContext} from "../../../PackingContext";
import SelectedItemPackingDrawer from "../SelectedItemPackingDrawer";

ShipmentMultiPacking.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    beginPacking: PropTypes.func.isRequired,
    packingStep: PropTypes.object.isRequired,
    beginShipmentWeigh: PropTypes.func.isRequired,
    setPackingStep: PropTypes.func.isRequired
};

function ShipmentMultiPacking({open, handleClose, beginPacking, packingStep, beginShipmentWeigh, setPackingStep}) {
    const {setEnableScan} = useContext(BarCodeScannerContext)
    const {handleAllItemAreCancelled, setOpenProductProblemDrawer} = useContext(PackingContext);

    const [isFormatted, setIsFormatted] = useState(false)
    const [formattedShipment, setFormattedShipment] = useState()
    const [containers, setContainers] = useState()
    const [openMultiHiveModal, setOpenMultiHiveModal] = useState(false)
    const [openBottomDrawer, setOpenBottomDrawer] = useState(false)
    const [selectedItem, setSelectedItem] = useState()
    const [isReadyToWeigh, setIsReadyToWeigh] = useState(false)

    const formatOptions = (options) => {
        const defaultLocale = store.getState().currentOrganization?.retrieved?.defaultLocale

        let optionsString = ""

        options.map((option) => {
            if (Object.keys(option.option).includes(defaultLocale) && Object.keys(option.value).includes(defaultLocale)) {
                optionsString += `${option.option[defaultLocale]} • ${option.value[defaultLocale]} `
            }
        })
        return optionsString
    }

    const handleClickOnItem = (item) => {
        setOpenBottomDrawer(true)
        setSelectedItem(item)
    }


    const handleCloseBottomDrawer = () => {
        setOpenBottomDrawer(false)
        setSelectedItem({})
    }

    const handleProductCancelled = (wmsItemId) => {
        let tempShipment = {...packingStep.selectedShipment}
        let allItemAreCancelled = true
        tempShipment.lineItems.map((lineItem) => {
            if (lineItem.wmsItem.id === wmsItemId) {
                lineItem.isCancelled = true
                lineItem.itemsCancelled++
                lineItem.wmsItem.status = WmsItemsStatus.CANCELED
            }

            if (lineItem.isCancelled === false) {
                allItemAreCancelled = false
            }
        })

        if (allItemAreCancelled) {
            handleAllItemAreCancelled()
            setPackingStep({
                ...packingStep,
                stepName: packingStepNames.RENEW
            })
        } else {
            setPackingStep({
                ...packingStep,
                selectedShipment: tempShipment
            })
            setOpenProductProblemDrawer({
                isOpen: false,
                product: null,
                handleProductCancelled: () => {}
            })
            setOpenBottomDrawer(false)
        }
    }

    const handleMultiHiveBeginPacking = () => {
        setOpenMultiHiveModal(false)
        beginPacking()
    }

    const handleCloseMultiHiveModal = () => {
        setOpenMultiHiveModal(false)
        handleClose()
    }

    const handleGroupItems = (shipment) => {
        let tempShipment = {...shipment}
        let items = [...shipment.lineItems]
        let groupedItems = []
        items.map((item) => {
            let foundItem = groupedItems.find(groupedItem => (
                item.eanCode === groupedItem.eanCode &&
                item.ugCode === groupedItem.ugCode &&
                item.wmsItem.currentContainer.codebar === groupedItem.wmsItem.currentContainer.codebar
            ))
            if (foundItem) {
                foundItem.totalItem++
                if (item.isPacked) {
                    foundItem.itemsScanned++
                }
            } else {
                item.totalItem = 1
                groupedItems.push(item)
            }
        })

        tempShipment.lineItems = groupedItems

        return tempShipment
    }

    useEffect(() => {
            let tempShipment = JSON.parse(JSON.stringify(packingStep.selectedShipment))

            tempShipment = handleGroupItems(tempShipment)

            setFormattedShipment(tempShipment)
            setIsFormatted(true)
    }, [packingStep.selectedShipment]);

    useEffect(() => {
        let areAllItemsPackedOrCancelled = true
        packingStep.selectedShipment.lineItems.map((lineItem) => {
            if (lineItem.isPacked === false && lineItem.isCancelled === false) {
                areAllItemsPackedOrCancelled = false
            }
        })
        if (areAllItemsPackedOrCancelled) {
            setEnableScan(false)

            if (Array.isArray(containers))
            containers.map((container) => {
                patchWmsContainersWithCodebar(container.codebar, {maxCapacity: false}).catch((r) => {})
            })
        }
        setIsReadyToWeigh(areAllItemsPackedOrCancelled)
    }, [packingStep.selectedShipment]);

    useEffect(() => {
        if (packingStep.stepName === packingStepNames.PACK_ITEMS) {
            beginMultiShipmentPacking(packingStep.selectedShipment.shipmentId).then((response) => {
                // Nothing here.
            })
        }
    }, [packingStep.stepName]);

    useEffect(() => {
        const lineItems = packingStep.selectedShipment.lineItems
        let wmsContainers = []

        lineItems.map(item => {
            if (!wmsContainers.some(container => container.codebar === item.wmsItem.currentContainer.codebar)) {
                wmsContainers.push(item.wmsItem.currentContainer)
            }
        })

        if (1 < wmsContainers.length) {
            setContainers(wmsContainers)
            setOpenMultiHiveModal(true)
        }

    }, []);

    return (
        <SelectedItemPackingDrawer
            open={open}
            handleClose={handleClose}
            packingStep={packingStep}
        >
            {openMultiHiveModal && (
                <MultiHiveModal
                    open={openMultiHiveModal}
                    handleClose={handleCloseMultiHiveModal}
                    containers={containers}
                    shipmentNumber={packingStep.selectedShipment.externalDeliveryNumber}
                    beginPacking={handleMultiHiveBeginPacking}
                    cancel={handleCloseMultiHiveModal}
                />
            )}


            {openBottomDrawer && selectedItem && (
                <SelectedItemPackingDrawer
                    open={openBottomDrawer}
                    handleClose={handleCloseBottomDrawer}
                    packingStep={packingStep}
                >
                    <WmsItemInformationPacking
                        lineItem={selectedItem}
                        packingStep={packingStep}
                        beginPacking={beginPacking}
                        beginShipmentWeigh={beginShipmentWeigh}
                        handleClose={handleCloseBottomDrawer}
                        handleProductCancelled={handleProductCancelled}
                    />
                </SelectedItemPackingDrawer>
            )}
            <Grid container direction={"column"} justifyContent={"space-between"} flexWrap={"nowrap"} sx={{height: "100%"}}>
                <Grid container direction={"column"}>
                    {formattedShipment && Object.values(formattedShipment.lineItems).map((lineItem) => {
                        const wmsContainer = lineItem.wmsItem.currentContainer
                        const options = formatOptions(lineItem.options)
                        const isValid = lineItem.itemsScanned === lineItem.totalItem
                        const inProgress = lineItem.itemsScanned > 0 && lineItem.itemsScanned < lineItem.totalItem
                        if (lineItem.isCancelled) {
                            return(<></>)
                        }
                        return(
                            <MobileItem onClick={() => handleClickOnItem(lineItem)}>
                                <MobileItem.LeftSide
                                    title={
                                        <div>
                                            <span>
                                                {lineItem.retailerName}
                                            </span> -&nbsp;
                                            <span style={{fontWeight: 400, fontSize: "12px"}}>
                                                {lineItem.name}
                                            </span>
                                        </div>
                                    }
                                    subtitle={options}
                                    underTitle={
                                        <span>
                                <Badge
                                    isBold={false}
                                    label={<>{wmsContainer.hiveName ? `${wmsContainer.hiveName} • ${wmsContainer.name}` : wmsContainer.name}</>}
                                    size={"large"}
                                    color={"default"}
                                />
                            </span>
                                    }
                                >
                                    <ThumbnailAndNotification validated={isValid} link={lineItem.pictures[0]} alt={lineItem.name}/>
                                </MobileItem.LeftSide>
                                <MobileItem.RightSide>
                                    <Badge
                                        isBold={false}
                                        label={<span>{lineItem.itemsScanned}/{lineItem.totalItem}</span>}
                                        color={isValid ? "online" : inProgress ? 'warning' : "info"}
                                        size={"large"}
                                        rounded
                                    />
                                </MobileItem.RightSide>
                            </MobileItem>
                        )
                    })}
                </Grid>
                <Grid container direction={"column"}>
                    {formattedShipment && Object.values(formattedShipment.lineItems).map((lineItem) => {
                        const wmsContainer = lineItem.wmsItem.currentContainer
                        const options = formatOptions(lineItem.options)
                        if (!lineItem.isCancelled) {
                            return(<></>)
                        }
                        return(
                            <MobileItem onClick={() => handleClickOnItem(lineItem)}>
                                <MobileItem.LeftSide
                                    title={
                                        <div>
                                            <span>
                                                {lineItem.retailerName}
                                            </span> -&nbsp;
                                            <span style={{fontWeight: 400, fontSize: "12px"}}>
                                                {lineItem.name}
                                            </span>
                                        </div>
                                    }
                                    subtitle={options}
                                    underTitle={
                                        <span>
                                <Badge
                                    isBold={false}
                                    label={<>{wmsContainer.hiveName ? `${wmsContainer.hiveName} • ${wmsContainer.name}` : wmsContainer.name}</>}
                                    size={"large"}
                                    color={"default"}
                                />
                            </span>
                                    }
                                >
                                    <ThumbnailAndNotification error={true} link={lineItem.pictures[0]} alt={lineItem.name}/>
                                </MobileItem.LeftSide>
                                <MobileItem.RightSide>
                                    <Badge
                                        isBold={false}
                                        label={<span>{lineItem.itemsCancelled}/{lineItem.totalItem}</span>}
                                        color={"error"}
                                        size={"large"}
                                        rounded
                                    />
                                </MobileItem.RightSide>
                            </MobileItem>
                        )
                    })}
                </Grid>
                <Grid item sx={{padding: "8px"}}>
                    {packingStep.stepName === packingStepNames.PEEK && (
                        <CustomButton fullWidth onClick={beginPacking}>
                            {/* Scan workstation */}
                            <FormattedMessage id={"wms.packing.item.button.beginPacking"}/>
                        </CustomButton>
                    )}
                    {packingStep.stepName === packingStepNames.PACK_ITEMS && isReadyToWeigh && (
                        <CustomButton fullWidth onClick={beginShipmentWeigh}>
                            {/* Scan workstation */}
                            <FormattedMessage id={"wms.packing.item.startWeighingShipment"}/>
                        </CustomButton>
                    )}
                </Grid>
            </Grid>
        </SelectedItemPackingDrawer>
    );
}

export default ShipmentMultiPacking;
